import React from "react";
import { Button, Col, FormLabel, Row } from "react-bootstrap";

import { AppContext } from "../AppContext.js";
import {
  BankAccountSearchCriteria,
  BatchPrintCheckTransactionBean,
  CheckTransactionSearchCriteria,
  RestBatchCheckTransactionListRequest,
  RestCheckTransactionListRequest,
  RestPageListBean,
  RestReadRequest,
  RestVendorListRequest,
  VendorSearchCriteria,
} from "../ds/ds.js";
import { PrintIcon } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DataGridColumnDefinition,
  DatePickerComponent,
  DatePickerComponent_adv,
  EditableDataGrid,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toFormattedDate_v1,
} from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { VendorLookupHandler } from "../lookup/VendorLookupHandler.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { AccountPayableService } from "../services/AccountPayableService.js";
import { MasterService } from "../services/MasterService.js";
import { VendorService } from "../services/VendorService.js";
import { BaseInquiryToolBar } from "./BaseModule.js";
import { PopCheckTransactionModule, PopupVendorModule } from "./ModuleUtil.js";
import CustomTable from "../gui_components/CustomTable.js";
import { ModuleUtils } from "./ModuleUtils.js";

class BatchCheckTransactionList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.vendorRef = React.createRef();
    this.state = {
      pageTitle: "Batch Check Transaction",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowExitButton: true,
      isShowResetButton: false,
      isShowPrintButton: false,
      isShowTitle: true,
      error_list: [],
      check_transaction_list: [],
      criteria: new CheckTransactionSearchCriteria(),
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMessage: [],
      alertType: "",
      alertMsg: "",
      success_list: [],
      moduleForPopup: [],
      isShowLookup: true,
      isDisabledFields: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      checkTransactionNumbers: [],
      isShowVendorModule: false,
      isShowCheckTransactionModule: false,
      isShowAutoCompleteBankList: false,
      bankPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteVendorList: false,
      vendorPageListForAutoCompleteList: new Array(),
      selectedRollSkuList: new Array(),
      banks: new Array(),
      vendor_List: new Array(),
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let banks = attribute_cache.bankAccounts;
    let banks_temp=[];
    banks.map((bank) => {
      banks_temp.push(bank);
      this.state.banks=ModuleUtils.isActiveAttribute(banks_temp);
    });
    this.getVendorList();
    this.initLookupHandlers();
  }
  moduleCaption = "Batch Check Transaction Maintenance";
  getVendorList = () => {
    let criteria = new VendorSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = new RestPageListBean();
    let requestInput = new RestVendorListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    if (SecurityAccessManager.BatchCheckTransactionMaintenance_IsAccessible()) {
      VendorService.getVendorPageList(
        requestInput,
        this.getVendorPageListResponse,
        this.getVendorPageListError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  getVendorPageListResponse = (response) => {
    const vendor_List = response.data.vendorPageList.vendors;
    this.setState({ vendor_List: vendor_List });
  };
  loadCheckTransactionPage = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let listRequest = new RestCheckTransactionListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.pageInput = pageInput;
    let isValidCriteria = this.validateCriteria(this.state.criteria);
    if (isValidCriteria) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Executing ...",
      });
      this.loadBatchCheckTransactionList(listRequest);
    } else {
      this.setState({
        progressLoadingText: "",
        isShowProgressBarPopup: false,
      });
    }
  };
  loadBatchCheckTransactionList = (listRequest) => {
    if (SecurityAccessManager.BatchCheckTransactionMaintenance_IsAccessible()) {
      AccountPayableService.getOpenCheckTransaction(
        listRequest,
        this.getCheckTransactionResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error: " + error);
  };
  validateCriteria = (searchCriteria) => {
    let isValidCriteria = false;
    let err_list = [];
    let errorMessage = "";
    if (searchCriteria == null) {
      let errMsg = "Invalid Input ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(searchCriteria.bankCode)) {
        let errMsg = "Bank is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (searchCriteria.checkNumber == 0) {
        let errMsg = "CheckNumber is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidCriteria = false;
      this.setState({ errorList: err_list });
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValidCriteria = true;
      this.setState({ isShowAlert: false });
    }
    return isValidCriteria;
  };
  getCheckTransactionResponse = (response) => {
    this.setState({
      progressLoadingText: "",
      isShowProgressBarPopup: false,
    });
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.pageList != null) {
      let resultList = new Array();
      if (!isEmptyArray(response.data.pageList.checkTransactions)) {
        resultList = response.data.pageList.checkTransactions;
        this.setState({
          isShowPrintButton: true,
        });
      }
      this.setState({
        check_transaction_list: resultList,
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
      });
      this.disable();
    } else {
      let errMsg = "No CHECK_TRANSACTION Found..!";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  printBatchCheck = (e) => {
    if (e.detail == 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Generating ...",
      });
      let temp_criteria = this.state.criteria;
      temp_criteria.companyCode = this.companyCode;
      let selectedRollSkuList = this.state.selectedRollSkuList;
      let batchCheckTransaction = new BatchPrintCheckTransactionBean();
      batchCheckTransaction.companyCode = this.companyCode;
      batchCheckTransaction.checkTransactionNumber = selectedRollSkuList;
      let request = new RestBatchCheckTransactionListRequest();
      request.batchCheckTransaction = batchCheckTransaction;
      request.checkNumber = temp_criteria.checkNumber;
      if (!isEmptyArray(selectedRollSkuList)) {
        if (
          SecurityAccessManager.BatchCheckTransactionPDFReport_IsAccessible()
        ) {
          AccountPayableService.printBatchCheckTransaction(
            request,
            this.printResponse,
            this.errorCallBack
          );
        } else {
          this.inValidAccess(2);
        }
      } else {
        let errMsg = "Select the Line";
        let error_list = [];
        error_list.push(errMsg);
        this.setState({
          alertMessage: error_list,
          alertType: "danger",
          isShowAlert: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  printResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.checkTransactionPrintResults != null
    ) {
      let reports = [];
      reports = response.data.checkTransactionPrintResults;
      reports.map((report) => {
        let reportFilePath = report.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  clearCriteria = () => {
    let criteria = new CheckTransactionSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.vendorName = "";
    criteria.fromDate = "";
    criteria.toDate = "";
    this.setState({ criteria: criteria });
    this.hideAlertCallBack();
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisabledFields: true,
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  checkTransactionColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", "isSelected", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setInputDetails(
          false,
          false,
          true,
          null,
          this.onCheckTransactionSelectedChange,
          null
        )
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CheckTrans#", "code", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.openCheckTransactionModule, null)
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Vendor#", "vendorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.openVendorModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "vendorName", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Bank", "bankCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "bankName", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Amount", "totalAmount", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("MemoText", "memoText", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Comments", "comments", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );

    return columns;
  };
  CheckTransactionDetailsColumnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "",
          "isSelected",
          0,
          false, //set hyperlink false
          null, //set hyperLink call back null
          false,
          null
        )
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.onCheckTransactionSelectedChange
        )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "CheckTrans#",
        "code",
        0,
        true, //set hyperlink false
        this.openCheckTransactionModule, //set hyperLink call back null
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Vendor",
        "vendorCode",
        0,
        true, //set hyperlink false
        this.openVendorModule, //set hyperLink call back null
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Name", "vendorName")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Bank", "bankCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Name", "bankName")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Amount", "totalAmount", 1)
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("MemoText", "memoText")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Location", "locationCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Coments", "comments")
    );
    return columnList;
  };
  onCheckTransactionSelectedChange = (e, rowData) => {
    let isSelected = false;
    let selectedRollSkuList = this.state.selectedRollSkuList;
    isSelected = e.target.value;
    rowData.isSelected = e.target.value;
    if (rowData.isSelected) {
      selectedRollSkuList.push(rowData.code);
    } else {
      const index = this.state.selectedRollSkuList.findIndex(
        (ln) => ln === rowData.code
      );
      if (index != -1) {
        this.state.selectedRollSkuList.splice(index, 1);
      }
    }
    this.setState({ selectedRollSkuList: selectedRollSkuList });
  };
  initLookupHandlers = () => {
    let vendorLookupHandler = new VendorLookupHandler(
      this.companyCode,
      "Vendor"
    );
    this.setState({ vendorLookupHandler: vendorLookupHandler });
    let bankLookupHandler = new GenericAttributeLookupHandler(
      this.state.banks,
      "Bank"
    );
    this.setState({ bankLookupHandler: bankLookupHandler });
  };
  onChange = (e) => {
    let temp_Criteria = this.state.criteria;
    temp_Criteria[e.target.name] = e.target.value;
    this.setState({
      criteria: temp_Criteria,
    });
  };
  readBank = (value) => {
    let readrestInput = new BankAccountSearchCriteria();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = value;
    if (SecurityAccessManager.BatchCheckTransactionMaintenance_IsAccessible()) {
      MasterService.readBankAccount(
        readrestInput,
        this.readBankResponse,
        this.readBankError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readBankResponse = (response) => {
    if (response.data != null && response.data.bankAccount != null) {
      let tempCheckTransactionCriteria = this.state.criteria;
      const bankAccountList = response.data.bankAccount;
      tempCheckTransactionCriteria.bankCode = bankAccountList.code;
      tempCheckTransactionCriteria.bankName = bankAccountList.description;
      tempCheckTransactionCriteria.checkNumber =
        bankAccountList.currentCheckNumber + 1;
      this.setState({ criteria: tempCheckTransactionCriteria });
    }
  };
  readBankError = (error) => {
    ShowError("Error : ", error);
  };
  bankOnChange = (e) => {
    let bankCode = e.target.value;
    this.state.isShowAutoCompleteBankList = true;
    let tempData = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompleteBankList;
    if (isEmpty(bankCode)) {
      this.state.isShowAutoCompleteBankList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteBankList;
      let tempData = this.state.criteria;
      tempData.bankCode = "";
      tempData.checkNumber = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        criteria: tempData,
        bankPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "bankCode" &&
      showAutoCompleteList === true &&
      bankCode !== ""
    ) {
      this.readBankBySearchString(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ criteria: tempData });
  };
  bankEnterKeyEvent = (e) => {
    this.readBank(e.target.value);
    this.state.isShowAutoCompleteBankList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteBankList;
    this.setState({
      bankPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayBankAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteBankList: isShowAutoCompleteList,
    });
  };
  readBankBySearchString = (searchString) => {
    let bankData = this.state.banks;
    let simpleAutoCompleteList = new Array();
    if (bankData.length > 0 && bankData != null) {
      bankData.map((obj) => {
        let bankBean = {
          description: obj.description,
          code: obj.code,
        };
        simpleAutoCompleteList.push(bankBean);
      });
    }

    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      bankPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  vendorOnChange = (e) => {
    let vendorCode = e.target.value;
    this.state.isShowAutoCompleteVendorList = true;
    let tempData = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompleteVendorList;
    if (isEmpty(vendorCode)) {
      this.state.isShowAutoCompleteVendorList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteVendorList;
      let tempData = this.state.criteria;
      tempData.vendorCode = "";
      tempData.vendorName = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteVendorList: showAutoCompleteList,
        criteria: tempData,
        vendorPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "vendorCode" &&
      showAutoCompleteList === true &&
      vendorCode !== ""
    ) {
      this.readVendorBySearchString(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({
      checkTransactionData: tempData,
    });
  };
  vendorEnterKeyEvent = (e) => {
    this.readVendor(e.target.value);
    this.state.isShowAutoCompleteVendorList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteVendorList;
    this.setState({
      vendorPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  displayVendorAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteVendorList: isShowAutoCompleteList,
    });
  };
  readVendorBySearchString = (searchString) => {
    let searchCriteria = new VendorSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.vendorCodeStartsWith = searchString;
    searchCriteria.vendorNameContains = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestVendorListRequest();
    input.searchCriteria = searchCriteria;
    input.pageInput = pageList;
    VendorService.getVendorPageList(
      input,
      this.readByVendorCodeResponse,
      this.errorCallBack
    );
  };
  readByVendorCodeResponse = (response) => {
    let vendorCodeData = response.data.vendorPageList.vendors;
    let simpleAutoCompleteList = new Array();
    if (vendorCodeData.length > 0 && vendorCodeData != null) {
      vendorCodeData.map((vendorCode) => {
        let simpleItemBean = {
          code: vendorCode.code,
          description: vendorCode.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      vendorPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readVendorResponse = (response) => {
    if (response.data != null) {
      if (response.data.vendor != null) {
        let vendorData = response.data.vendor;
        let criteria = this.state.criteria;
        criteria.vendorCode = vendorData.code;
        criteria.vendorName = vendorData.description;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readVendor = (vendorCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = vendorCode;
    if (SecurityAccessManager.BatchCheckTransactionMaintenance_IsAccessible()) {
      VendorService.readVendor(
        readrestInput,
        this.readVendorResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  resetView = () => {
    let criteria = new CheckTransactionSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.vendorName = "";
    this.setState({
      isInquiryDatasFound: false,
      check_transaction_list: new Array(),
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isShowPrintButton: false,
      isDisabledFields: false,
      criteria: criteria,
    });
    this.hideAlertCallBack();
  };
  openVendorModule = (e, code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowVendorModule: true,
        moduleForPopup: (
          <PopupVendorModule
            vendorCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCheckTransactionModule = (e, code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowCheckTransactionModule: true,
        moduleForPopup: (
          <PopCheckTransactionModule
            code={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowVendorModule: isOpen,
      isShowCheckTransactionModule: isOpen,
      moduleForPopup: [],
    });
  };
  render() {
    let criteria = this.state.criteria;
    let check_transaction_list = this.state.check_transaction_list;

    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />

        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowVendorModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowCheckTransactionModule}
          popupLvlClass={"popupSizeLevel0"}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExitButton={this.state.isShowExitButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowResetButton={this.state.isShowResetButton}
          onModuleExit={this.moduleExit}
          execute={this.loadCheckTransactionPage}
          clearCriteria={this.clearCriteria}
          reset={this.resetView}
          extend_toolbar={
            <>
              {this.state.isShowPrintButton && (
                <Button
                  className="header_buttons secondary"
                  size="sm"
                  onClick={(e) => this.printBatchCheck(e)}
                >
                  <PrintIcon />
                  Print
                </Button>
              )}{" "}
            </>
          }
        />
        {/* <BaseToolBar
          clearCriteria={this.clearCriteria}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          pageTitle={this.moduleCaption}
          // pageTitle={this.state.pageTitle}
          // isShowTitle={this.state.isShowTitle}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.moduleExit}
          extend_toolbar={
            <>
              {this.state.isShowPrintButton && (
                <Button
                  className="header_buttons"
                  size="sm"
                  onClick={(e) => this.printBatchCheck(e)}
                >
                  <PrintIcon />
                  Print
                </Button>
              )}{" "}
              {this.state.isShowExecuteButton && (
                <Button
                  className="header_buttons"
                  size="sm"
                  onClick={(e) => this.loadCheckTransactionPage(e)}
                >
                  Execute
                </Button>
              )}{" "}
              {this.state.isShowResetButton && (
                <Button
                  className="header_buttons"
                  size="sm"
                  onClick={(e) => this.resetView(e)}
                >
                  Reset
                </Button>
              )}{" "}
            </>
          }
        /> */}
        <div className="header_div">
          <div className="">
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel>Vendor</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  ref={this.vendorRef}
                  onChange={this.vendorOnChange}
                  placeholder="vendorCode"
                  name="vendorCode"
                  value={criteria.vendorCode}
                  lookupRequired={true}
                  lookupHandler={this.state.vendorLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.vendorEnterKeyEvent}
                  autoCompleteListData={
                    this.state.vendorPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayVendorAutoCompleteList}
                  showAutoCompleteList={this.state.isShowAutoCompleteVendorList}
                  disabled={this.state.isDisabledFields}
                />
              </Col>
              <Col sm="3">
                <InputTextbox
                  onChange={this.onChange}
                  name="vendorName"
                  value={criteria.vendorName}
                  disabled={true}
                />{" "}
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>Bank</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.bankOnChange}
                  placeholder="bankCode"
                  name="bankCode"
                  value={criteria.bankCode}
                  lookupRequired={true}
                  lookupHandler={this.state.bankLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.bankEnterKeyEvent}
                  autoCompleteListData={
                    this.state.bankPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayBankAutoCompleteList}
                  showAutoCompleteList={this.state.isShowAutoCompleteBankList}
                  disabled={this.state.isDisabledFields}
                  isMandatory={true}
                />
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>Check#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onChange}
                  name="checkNumber"
                  placeholder="checkNumber"
                  value={criteria.checkNumber}
                  disabled={this.state.isDisabledFields}
                  isMandatory={true}
                ></InputTextbox>
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>From Date</FormLabel>
              </Col>
              <Col sm="2">
                <DatePickerComponent
                  name="fromDate"
                  onChange={this.onChange}
                  value={criteria.fromDate}
                  disabled={this.state.isDisabledFields}
                />
              </Col>
              <Col sm="1">
                <FormLabel>To Date</FormLabel>
              </Col>
              <Col sm="2">
                <DatePickerComponent
                  name="toDate"
                  onChange={this.onChange}
                  value={criteria.toDate}
                  disabled={this.state.isDisabledFields}
                />
              </Col>
            </Row>
          </div>
          {this.state.isInquiryDatasFound && (
            <div className="div_default">
              {/* <EditableDataGrid
                columnsList={this.CheckTransactionDetailsColumnDefinitions()}
                dataList={check_transaction_list}
              /> */}
              <CustomTable
                data={check_transaction_list}
                columns={this.checkTransactionColumns()}
                label={"Check Tansaction Lines"}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}
function BatchCheckTransactionModule(props) {
  return (
    <div>
      <div id="app_container"></div>
      <BatchCheckTransactionList {...props} name="" /> <br />
    </div>
  );
}

export default BatchCheckTransactionModule;
